<template>
  <div class="service wrap">
    <SlotPageVisual class="half">
      <template #visual-bg>
        <div class="img service"></div>
      </template>
      <template #contents>
        <h1 class="visual-title">
          <span data-aos="fade"><span class="hl">S</span>ervice</span>
        </h1>
        <p class="visual-summary">
          <span data-aos="fade-up" data-aos-delay="500">
            {{ $t('service.desc.01') }}
          </span>
          <br />
          <span data-aos="fade-up" data-aos-delay="1000">
            {{ $t('service.desc.02') }}
          </span>
        </p>
      </template>
    </SlotPageVisual>

    <MenuLinkGrid :items="serviceItems" />
  </div>
</template>
<script>
import SlotPageVisual from '@/components/SlotPageVisual'
import MenuLinkGrid from '@/components/MenuLinkGrid'

export default {
  name: 'ServiceView',
  components: { SlotPageVisual, MenuLinkGrid },
  computed: {
    serviceItems () {
      return [
        {
          title: this.$t('service.title.keycloak'),
          sub: 'Identity & Access Management',
          desc: this.$t('service.summary.keycloak'),
          to: '/service/keycloak',
          accent: '#2563eb'
        },
        {
          title: this.$t('service.title.aiData'),
          sub: 'AI & Data Analytics',
          desc: this.$t('service.summary.aiData'),
          to: '/service/ai-data',
          accent: '#7c3aed'
        },
        {
          title: this.$t('service.title.cloud'),
          sub: 'Cloud Consulting',
          desc: this.$t('service.summary.cloud'),
          to: '/service/cloud-consulting',
          accent: '#0891b2'
        },
        {
          title: this.$t('service.title.maintenance'),
          sub: 'Operations & Maintenance',
          desc: this.$t('service.summary.maintenance'),
          to: '/service/maintenance',
          accent: '#059669'
        }
      ]
    }
  }
}
</script>
